import { extractTags } from "./propertyExtraction";
import {
  getLaneDirectionArrowStyles,
  LANE_TYPES,
} from "./util/laneDirectionArrows";
import { roadClassStrokes } from "./util/roadClassStrokes";

// Lane road-class view of the LM basemap: centre and trajectory lines coloured by
// the highway class of their road area. The class is not on the lane itself;
// laneRoadClassHandler copies it over as `laneRoadClass`.
//
// Trajectory lines are drawn one pixel thinner to keep them apart from centre
// lines, now that colour no longer does that (not dashed, see roadClassStrokes).
const TRAJECTORY_THINNING = 1;

export function getLaneRoadClassStyleNormal(feature, resolution) {
  return getLaneRoadClassStyle(feature, resolution, 3);
}
export function getLaneRoadClassStyleClick(feature, resolution) {
  return getLaneRoadClassStyle(feature, resolution, 6);
}
export function getLaneRoadClassStyleHover(feature, resolution) {
  return getLaneRoadClassStyle(feature, resolution, 5);
}

function getLaneRoadClassStyle(feature, resolution, width) {
  if (feature.get("type") === "ORBIS_RELATION") {
    return;
  }
  const tags = extractTags(feature);
  if (!LANE_TYPES.includes(tags.hdMap)) {
    return;
  }
  const laneWidth =
    tags.hdMap === "lane_trajectory_line" ? width - TRAJECTORY_THINNING : width;
  return [
    ...roadClassStrokes(feature.get("laneRoadClass"), laneWidth),
    ...getLaneDirectionArrowStyles(
      feature,
      tags.laneDirection,
      "black",
      resolution,
    ),
  ];
}
